module.exports = __webpack_public_path__ + "media/audio6.de83504a.mp3";